import React from "react";
import { Skeleton, Row, Col } from "antd";

const LoadSkeleton = ({ rowProps, colProps }) => (
  <Row {...rowProps}>
    <Col {...colProps}>
      <Skeleton loading active />
    </Col>
  </Row>
);

export default LoadSkeleton;
